
<div class="top-menu" id="top-menu" *ngIf="this.company">
  <div class="menu-container">
      <div class="menu-company">
        <div class="menu-company__logo"><img [src]="this.img" /></div>
        <div class="menu-company__name">{{ this.company.company.companyName }}</div>
      </div>
      <ng-container *ngIf="this.company">
        <div class="menu-top-buttons" *ngIf="!this.readOnlyState" style="font-size: 19px;">
          <a [routerLink]="['/', this.nameCompany, 'carrinho']" routerLinkActive="active"><i class="icon-shopping-cart" style="font-size: 19px; text-align: center;" aria-hidden="true"></i><span>Carrinho</span><span *ngIf="this.counterCart > 0" class="icon-quantity">{{ counterCart }}</span></a>
          <a [routerLink]="['/', this.nameCompany, 'consumption']" *ngIf="this.verificationTable" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Consumo</span></a>
          <a [routerLink]="['/', this.nameCompany, 'pedidos']" *ngIf="this.userConfirmation && !this.verificationTable" routerLinkActive="active"><i class="icon-book-open-text" style="text-align: center;"></i><span>Pedidos</span></a>
          <a [routerLink]="['/', this.nameCompany, 'user']" *ngIf="!this.verificationTable" routerLinkActive="active"><i class="icon-user" style="text-align: center;"></i><span>Perfil</span></a>
        </div>
      </ng-container>
  </div>
</div>